import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import * as Highcharts from 'highcharts';
import { TranslationService } from '../../../../core/services/translation.service';
import { DEFAULT_CHART_OPTIONS } from '../chart.constants';

const selectPointInChart = (event, point) => {
  point.onMouseOver();
  point.series.chart.tooltip.refresh(point);
  point.series.chart.xAxis[0].drawCrosshair(event, point);
};

@Component({
  selector: 'app-chart',
  templateUrl: './chart.component.html',
  styleUrls: ['./chart.component.css']
})
export class ChartComponent implements OnChanges, OnInit {
  chartOptions: any;
  Highcharts = Highcharts;
  updateFlag = false;
  chart;
  @Input() options: any;
  @Input() main = false;
  @Output() select = new EventEmitter<any>();

  constructor(private translationService: TranslationService) { }

  ngOnInit() {
    Highcharts.setOptions(this.translationService.getTranslationSync('shared.charts'));
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['options']) {
      this.chartOptions = Highcharts.merge(DEFAULT_CHART_OPTIONS, this.options);
      this.updateFlag = true;
    }
  }

  loadChart = (chart) => this.chart = chart;

  highlightPoint(event) {
    const normalizedEvent = this.chart.pointer.normalize(event);
    const point = this.chart.series[0].searchPoint(normalizedEvent, true);

    if (point) {
      selectPointInChart(event, point);
      if (this.main) {
        this.select.emit(point);
      }
    }
  }

  unsetHighlightedPoint() {
    const point = this.chart.hoverPoint;
    if (point) {
      point.onMouseOut();
      point.series.chart.tooltip.hide();
      point.series.chart.xAxis[0].hideCrosshair();
    }

    if (this.main) {
      this.select.emit(null);
    }
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/shared/components/charts/chart/chart.component.ts